import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles.css'
import './registerServiceWorker'

// 正式发布版本：禁用所有 console 输出
// 这将禁用 console.log, console.warn, console.error, console.debug, console.info
// 用于 public-version 分支的生产环境
console.log = () => {};
console.warn = () => {};
console.error = () => {};
console.debug = () => {};
console.info = () => {};

createApp(App).mount('#app')